module.exports = __webpack_public_path__ + "safari-pinned-tab.1662ad57.svg";